import type { ViewMode } from './VistaToggle.types'

/** Una opción del toggle: su disposición y su etiqueta accesible. */
interface VistaOption {
  readonly value: ViewMode
  /** Etiqueta accesible: los botones son icon-only y la necesitan. */
  readonly ariaLabel: string
}

/** Etiqueta accesible por defecto del grupo. */
export const DEFAULT_GROUP_LABEL = 'Cambiar vista de resultados'

/** Opciones del toggle, en el mismo orden que la referencia de diseño (lista → cuadrícula). */
export const VISTA_OPTIONS: ReadonlyArray<VistaOption> = [
  { value: 'horizontal', ariaLabel: 'Vista en lista' },
  { value: 'vertical', ariaLabel: 'Vista en cuadrícula' },
]
